import { render, staticRenderFns } from "./ColaboracoesModeradas.vue?vue&type=template&id=37f3c194&scoped=true"
import script from "./ColaboracoesModeradas.vue?vue&type=script&lang=js"
export * from "./ColaboracoesModeradas.vue?vue&type=script&lang=js"
import style0 from "./ColaboracoesModeradas.vue?vue&type=style&index=0&id=37f3c194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3c194",
  null
  
)

export default component.exports